import { Link } from '@tanstack/react-router'
import AvatarPlaceHolder from '@/assets/avatar/avatar_placeholder.png'
import { useAuthStore } from '@/stores/authStore'
import { useSignOut } from '@/hooks/use-sign-out'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens'

export function ProfileDropdown() {
  const user = useAuthStore((state) => state.auth.user)
  const { signOut } = useSignOut()
  const { t } = useTranslation();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' className='relative h-8 w-8 rounded-full'>
          <Avatar className='h-8 w-8'>
            <AvatarImage
              src={user?.user_metadata.avatar_url}
              alt={user?.user_metadata.name}
            />
            <AvatarFallback>
              <img src={AvatarPlaceHolder} style={{ maxWidth: '100%' }} />
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-56' align='end' forceMount>
        <DropdownMenuLabel className='font-normal'>
          <div className='flex flex-col space-y-1'>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <p className='text-sm leading-none text-muted-foreground py-1 truncate'>
                    {user?.email || 'user@email.com'}
                  </p>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{user?.email || 'user@email.com'}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link to='/settings/usage'>
              {t(tokens.settings.title)}
              <DropdownMenuShortcut>⌘P</DropdownMenuShortcut>
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut}>
          {t(tokens.ui.auth.logout)}
          <DropdownMenuShortcut>⇧⌘Q</DropdownMenuShortcut>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
